import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Input, Button, Select } from 'antd';
import { Refresh, Search, ArrowDropDown } from '@material-ui/icons';
import { Campaign } from 'core/worldCup/customerSupport/types';

const { Option } = Select;

type CustomerSupportFilterType = {
  searchText: string;
  handleSearch: (e: any) => void;
  onSort: (e: string) => void;
  onApplyFilter: () => void;
  campaigns: Campaign[];
  selectedCampaignId: number | null;
  onCampaignChange: (campaignId: number) => void;
};

const CustomerSupportFilter: React.FC<CustomerSupportFilterType> = ({
  searchText,
  handleSearch,
  onSort,
  onApplyFilter,
  campaigns,
  selectedCampaignId,
  onCampaignChange,
}) => {
  const intl = useIntl();

  const sortOptions = [
    { value: 'Idesc', label: intl.formatMessage({ id: 'ID (desc)' }) },
    { value: 'Iasc', label: intl.formatMessage({ id: 'ID (asc)' }) },
    { value: 'Ddesc', label: intl.formatMessage({ id: 'Date (Newest first)' }) },
    { value: 'Dasc', label: intl.formatMessage({ id: 'Date (Oldest first)' }) },
  ];

  return (
    <div className="customerSupport_filter_layout" id="customerSupport_filter_layout">
      <Select
        className="campaign_select"
        suffixIcon={<ArrowDropDown />}
        placeholder={intl.formatMessage({ id: 'Select campaign' })}
        value={selectedCampaignId || undefined}
        onChange={onCampaignChange}
        id="customerSupport_campaign_filter"
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
      >
        {campaigns.map(campaign => (
          <Option value={campaign.id} key={campaign.id} style={{ fontFamily: 'Lato', color: '#242c40' }}>
            {campaign.name}
          </Option>
        ))}
      </Select>
      <Select
        className="sort_by"
        suffixIcon={<ArrowDropDown />}
        placeholder={intl.formatMessage({ id: 'Sort by' })}
        onChange={onSort}
        id="customerSupport_sort_filter"
        dropdownStyle={{ paddingLeft: '0', paddingRight: '0' }}
      >
        {sortOptions.map(item => (
          <Option value={item.value} key={item.label} style={{ fontFamily: 'Lato', color: '#242c40' }}>
            {item.label}
          </Option>
        ))}
      </Select>
      <Button className="apply_filters_btn" onClick={onApplyFilter} id="customerSupport_apply_filters_btn">
        <FormattedMessage id="Apply filters" />
        <Refresh />
      </Button>
      <Input
        suffix={<Search />}
        placeholder={intl.formatMessage({ id: 'Search participation' })}
        value={searchText}
        onChange={e => handleSearch(e)}
        onKeyDown={e => handleSearch(e)}
        id="customerSupport_search_input"
        maxLength={200}
      />
    </div>
  );
};

export default CustomerSupportFilter;
